import { getVersion } from './App.utils';

describe('App.utils.js', () => {
  it('when the pathname contains the version number, return the version number', () => {
    const pathname = '/v0.x/component/overview';
    const latestVersion = 'v1.x';
    const result = getVersion(pathname, latestVersion);
    expect(result).toBe('v0.x');
  });

  it('when the pathname does not contains a version number, return the latest version', () => {
    const pathname = '/component/overview';
    const latestVersion = 'v1.x';
    const result = getVersion(pathname, latestVersion);
    expect(result).toBe('v1.x');
  });
});
